export default __webpack_public_path__ + "static/media/Signature.7f261785.svg";